const groupPrefix = 'special-daily-offers'

export const apiSpecialDailyOffers = {
	fetchSpecialDailyOffer: async (type: ESpecialDailyOfferType) => {
		const { data } = await apiCommon<ISpecialDailyOffers>(`${groupPrefix}/${type}`, {
			method: 'GET',
		})

		return SpecialDailyOffer(data)
	},
}
